import { render, staticRenderFns } from "./AiTutorBot.vue?vue&type=template&id=9b7c2f08&"
import script from "./AiTutorBot.vue?vue&type=script&lang=js&"
export * from "./AiTutorBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports